<div class="app-root">
    <router-outlet />
</div>